import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Controparte } from 'src/app/common/models/controparte';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { Observable, Subject, combineLatest, concat } from 'rxjs';
import { Parte } from 'src/app/common/models/parte';
import { ViewChild } from '@angular/core';
import { RicercaAnagraficheFormComponent } from 'src/app/common/form/ricerca-anagrafiche-form.component';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { OperationsService } from 'src/app/core/services/operations.service';
import { SearchAnagraficheResponse } from 'src/app/common/models/dto/search-anagrafiche-response';
import { Anagrafica } from 'src/app/common/models/anagrafica';
import { AssociazioneControparteFormComponent } from './associazione-controparte-form/associazione-controparte-form.component';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { TipoPersona } from 'src/app/common/models/tipologiche/tipo-persona';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { extractParteEntityFromSearch, isControparteAssociated, isDuplicate, isParteAssociable, parteFromEntity, setTempId } from '../../utils/parti-utils';
import { filterElaborationEntity, filterElaborationEntityClean, getMockEntity, removeDuplicates as removeDuplicatesEntities } from '../../utils/wizard-utils';
import { ElaborationEntityConstants } from '../../constants/elaboration-entity-constants';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { distinctUntilChanged, filter, skipWhile, take, takeUntil, tap } from 'rxjs/operators';
import { refreshContropartePrimaria } from '../../utils/controparti-utils';
import { Router } from '@angular/router';
import { stepMap } from '../creazione-pratica-stepper/config/step';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { DocumentoAddModal } from 'src/app/common/components/documenti/documento-add/documento-add-modal.component';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { DocumentVersionHistoryModal } from 'src/app/common/components/documenti/documento-history-version/document-version-history-modal.component';
import { DocumentUpdateMetadatiModal } from 'src/app/common/components/documenti/documento-update-metadati/document-update-metadati-modal.component';
import { DocumentVersionUpdateModal } from 'src/app/common/components/documenti/documento-version-update/document-version-update-modal.component';
import { SearchTextComponent } from 'src/app/common/components/input-component/searchText/search-text.component';
import { UpdateMetadatiComponent } from 'src/app/common/components/fascicolo/documentazione-allegata-view/metadati/update-metadati/update-metadati.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';

declare var closeModal: any;
@Component({
  selector: 'step-parti',
  templateUrl: './step-parti.component.html',
  styleUrls: ['./step-parti.component.css']
})
export class StepPartiComponent<T extends Anagrafica> implements OnInit, OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @ViewChild('formRicercaParte') modaleRicerca: RicercaAnagraficheFormComponent<Parte>;
  requestSearchUrl = ServicePathsSettings.URL_SEARCH_PARTE;
  activeTab = 0;
  action:string;
  suggested: {isAssociable:boolean,isControparte:boolean, hasDetailsAnagrafica: boolean, anagrafica: any, categoria?: string, tipoSoggetto?: string }[] = [];
  options: {isAssociable:boolean,isControparte:boolean, hasDetailsAnagrafica: boolean, anagrafica: any }[] = [];
  controparti: Controparte[] = [];
  private tipoPersonaOptions: TipoPersona[] = [];
  private entities: ElaborationDocumentFilterEntity[];
  controparteTmp: Controparte = null;
  parteTmp: Parte = null;
  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>()
  count = 0;
  totalResults = 0;
  isConcatSearch: boolean = false;
  waitResponseSearch: boolean = false;
  sezione = null;
  fascicolo = null;
  accordions = stepMap;
  searchText: string = null;
  componentDestroyed$: Subject<void> = new Subject<void>();
  @ViewChild('docAddModalParti') docAddModalParti: DocumentoAddModal;
  @ViewChild('docVersionHistoryParti') docVersionHistoryParti: DocumentVersionHistoryModal;
  @ViewChild('docVersionUpdateModalParti') docVersionUpdateModalParti: DocumentVersionUpdateModal;
  @ViewChild('searchElement') searchElement: SearchTextComponent;
  constructor(
    private operations: OperationsService,
    private tipologicheService: CreazionePraticaTipologicheService,
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private router: Router,
    private viewManager: ViewManagerService,
    private dialog: DialogService
  ) {
    this.creazionePraticaStoreService._docAdd.subscribe(
      data => {
      if(data?.tipoSezione?.descrizione === "CONTROPARTI") {
          if(!!this.sezione) {
            this.sezione.documentiAggregati = data.documentiAggregati;
            this.controparti = [...data.controparti];
            this.creazionePraticaStoreService.setControparti(data.controparti);
            this.creazionePraticaStoreService.save();
          }
       
        }
      }
    )
  } 


  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.creazionePraticaStoreService.setControparti(null);
    this.creazionePraticaStoreService.save();
  }

  ngOnInit() {
    this.suggested = [];
    this.options = [];
    this.entities = [];
    this.count = 0;
    this.totalResults= 0;
    this.viewManager.initializeBody();
    this.readSezione();
    if (this.modaleRicerca) this.modaleRicerca.inizializza(ServicePathsSettings.URL_SEARCH_PARTE, true);


    const partiSuggestedStored$ = this.creazionePraticaStoreService.suggestedParti$.pipe(
      take(1),
      filter(suggested => suggested.length > 0),
      tap(suggested => this.suggested = suggested)
      );

    const entitiesAndTipiPersona$ = combineLatest(
      this.creazionePraticaStoreService.entities$.pipe(
        distinctUntilChanged(),
        filter(entities => entities.length > 0),
        tap(entities => {
          this.entities = filterElaborationEntityClean(entities, [ElaborationEntityConstants.PRINCIPAL_ACTOR]);
        })
      ),
      this.tipologicheService.getTipiPersona().pipe(
        distinctUntilChanged(),
        tap(tipoPersonaOptions => this.tipoPersonaOptions = tipoPersonaOptions)
      )
    ).pipe(take(1));

    concat(partiSuggestedStored$, entitiesAndTipiPersona$).pipe(
      takeUntil(this.componentDestroyed$),
      skipWhile(() => this.suggested.length > 0)
    ).subscribe(() => this.getSuggeriti());

  }

  private getSuggeriti() {
    if (this.entities && this.entities.length > 0 && this.tipoPersonaOptions && this.tipoPersonaOptions.length > 0) {

      if(this.router.url.endsWith('consultazione')){//logica per il nuovo wizard di consultazione
        let outputArray: ElaborationDocumentFilterEntity[] = [];

        this.entities.forEach(obj => {
            let cleanedValore = obj.valore.replace(/nome:|cognome:|ragioneSociale:/g, "").trim();
           let  formattedObj = Object.assign({}, obj);
           formattedObj.valore = cleanedValore;
           outputArray.push(formattedObj);
        });
        //outputArray = entities senza i prefissi nome e cognome
        //per ogni entita cerca simili su elastic search
        outputArray.forEach(element => this.operations.searchAnagrafiche(ServicePathsSettings.URL_SEARCH_PARTI_TUTTE, { searchText: element.valore.substring(0, element.valore.indexOf(" categoria")), fromResult: 0 }).subscribe(response => {
          let filteredResponse = response
          let anagraficheResponse: any[] = [];
          if(response.anagrafiche && response.anagrafiche !== null){
            response.anagrafiche.forEach(response => {
              if(response.nome && element.valore.includes(response.nome) &&
                  response.cognome && element.valore.includes(response.cognome)) {
                if (element.uri.includes('_') && response.codiceFiscale) {
                  if (element.uri.includes(response.codiceFiscale)) {
                    if (!isDuplicate(response, anagraficheResponse))
                      anagraficheResponse.push(response);
                  }
                } else {
                  if (!isDuplicate(response, anagraficheResponse))
                    anagraficheResponse.push(response);
                }
              } else if(response.ragioneSociale && element.valore.includes(response.ragioneSociale)) {
                if (element.uri.includes('_') && response.partitaIva) {
                  if (element.uri.includes(response.partitaIva)) {
                    if (!isDuplicate(response, anagraficheResponse))
                      anagraficheResponse.push(response);
                  }
                } else {
                  if (!isDuplicate(response, anagraficheResponse))
                    anagraficheResponse.push(response);
                }
              }
            })
          }
          filteredResponse.anagrafiche = anagraficheResponse;
          this.suggerimentiDaRicerca(filteredResponse, element);
          this.creazionePraticaStoreService.setSuggestedParti(this.suggested);
         })
        )

      } else {
      this.entities.forEach(element => {
        this.operations.searchAnagrafiche(ServicePathsSettings.URL_SEARCH_PARTI_TUTTE, { searchText: element.valore, fromResult: 0 }).subscribe(response => {
        this.suggerimentiDaRicerca(response, null);
        this.creazionePraticaStoreService.setSuggestedParti(this.suggested);
       });
      });
    }
      this.checkParteisControparte();
    }
  }

  public retrieveSearch(response: SearchAnagraficheResponse) {
    if (response && response.numeroAnagTotali) {
      this.totalResults = response.numeroAnagTotali;
    } else {
      this.totalResults = 0;
    }
    if (!this.isConcatSearch) {
      this.options = [];
    }
    let listaFiltrata: T[] = [];
    if (response && <T[]>response.anagrafiche) {
      listaFiltrata = <T[]>response.anagrafiche;
      for (let element of listaFiltrata) {
        let isAssociable = isParteAssociable(element);
        this.options.push({isAssociable:isAssociable,isControparte:false, hasDetailsAnagrafica: false, anagrafica: element });
      }
    }
    this.isConcatSearch = false;
    this.waitResponseSearch = false;
  }

  onParteInsert(parte: Parte) {
    this.parteTmp = parte;
  }

  retrieveParte(parte: Parte) {  
    this.parteTmp = parte;
    this.salvaParte(this.parteTmp);
  }  

  salvaParte(parte:Parte): void {
    const parteIstanza = new Parte();
    Object.assign(parteIstanza, parte);
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO);
    let idFascicolo = this.accordions[index].properties.fascicolo.id;
    if (parte) {
      this.parteTmp = parte;
      this.operations.updateAnagraficaElementParte(parteIstanza).subscribe({
        next: response => {
          if (response) {
            this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
              res => {
                this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
                this.accordions[index].complete = true;
                this.readSezione();
                this.controparteTmp = null;
                this.parteTmp = null;
              }
            );
          }
        }
      }); 
    }
  }

  retrieveControparte(controparte: any){
    if(controparte.type === "modifica") {
      if(!!this.parteTmp) {
        controparte.controparte.parte = this.parteTmp;
      }
      let contropartiFiltred = refreshContropartePrimaria(this.controparti,controparte.controparte);
      this.controparteTmp = controparte.controparte;
      this.salva(true);
      this.activeTab = 0;
      this.resetSearch();
      return
    }
    if(!!this.parteTmp) {
      controparte.parte = this.parteTmp;
    }
    let contropartiFiltred = refreshContropartePrimaria(this.controparti,controparte);
    this.controparteTmp = controparte;
    this.salva();
    this.activeTab = 0;
    this.resetSearch();
  }

  resetSearch() {
    this.searchText = null;
    this.options = [];
    if (this.searchElement) {
      this.searchElement.reset();
    }
  }

  salva(editMode = false): void {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO);
    let idSezione =
      !!this.accordions[index].properties.fascicolo.idSezioneControparti
        ? this.accordions[index].properties.fascicolo.idSezioneControparti
        : "new";
    let idFascicolo = this.accordions[index].properties.fascicolo.id;
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    if(!editMode) {
      this.add(index, idSezione, idFascicolo);
    } else {
      this.update(tipoPratica, tipoFascicolo, idSezione, index, idFascicolo);
    }
  }

  private update(tipoPratica: any, tipoFascicolo: any, idSezione: any, index: number, idFascicolo: any) {
    this.operations.updateControparte(
      this.controparteTmp,
      tipoPratica,
      tipoFascicolo,
      idSezione
    ).subscribe(res => {
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.accordions[index].complete = true;
          this.readSezione();
          this.controparteTmp = null;
          this.parteTmp = null;
        }
      );
    });
  }

  onSearchChange(searchText: string) {
  this.searchText = searchText;
  this.options = [];
  this.isConcatSearch = false;
  this.searchElement.fromResult = 0;
  if (!searchText.trim()) {
    return;
  }

  this.waitResponseSearch = true;
  this.searchElement.manageValue(true);
}


  private add(index: number, idSezione: string, idFascicolo: string) {
    this.operations.addControparte(
      this.controparteTmp,
      this.accordions[index].properties.urlInsert,
      idSezione,
      idFascicolo
    ).subscribe(res => {
      this.controparti = res.sezione.controparti
      this.creazionePraticaStoreService.setControparti(res.sezione.controparti);
      this.creazionePraticaStoreService.save();
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.accordions[index].complete = true;
          this.readSezione();
          this.controparteTmp = null;
          this.parteTmp = null;
        }
      );
    });
  }

  private delete(index: number, idSezione: string, option: { hasDetailsAnagrafica: boolean, controparte: Controparte }) {
    this.operations.deleteControparte(
      this.accordions[index].properties.urlInsert, 
      idSezione, 
      option.controparte.id
    ).subscribe(
      () => {
        this.controparti = this.controparti.filter(controparte => controparte.parte.id !== option.controparte.parte.id)
        this.creazionePraticaStoreService.setControparti(this.controparti);
        this.creazionePraticaStoreService.save();
        this.readSezione();
      }
    );
  }

  reset(): void {
    this.count = 0;
    this.creazionePraticaStoreService.setControparti([]);
    this.creazionePraticaStoreService.save();
    // this.suggested = []
    // this.options = []
    // this.getSuggeriti();
  }

  private checkParteisControparte(){
    this.suggested.forEach(element => {
      isControparteAssociated(element , this.controparti)
    });
  }

  private suggerimentiDaRicerca(response: SearchAnagraficheResponse, entity) {
    let categoria;
    let  tipoSoggetto;
    this.count = this.count + 1;
    let listaFiltrata: any[] = [];
    if (response && response.anagrafiche) {
      listaFiltrata = response.anagrafiche;
      for (let element of listaFiltrata) {
        if(!element.rimosso){
            if(entity) {
              if (entity.valore.includes('categoria: ') && entity.valore.includes('tipoSoggetto: ')) {
                //recupera dal valore categoria e tipo
                categoria = entity.valore.substring(entity.valore.indexOf('categoria: ') + 'categoria: '.length, (entity.valore.indexOf(' tipoSoggetto: ')));
                tipoSoggetto = entity.valore.substring(entity.valore.indexOf('tipoSoggetto: ') + 'tipoSoggetto: '.length);
              } else {
                categoria = null;
                tipoSoggetto = null
              }

            }
            let isAssociable = isParteAssociable(element);
            this.suggested.push({ isAssociable: isAssociable, isControparte: false, hasDetailsAnagrafica: false, anagrafica: element, categoria: categoria !== '-' ? categoria : null, tipoSoggetto: tipoSoggetto != '-' ? tipoSoggetto : null});
        }
      }
    }
    if (this.count === this.entities.length) {
      let parti: Parte[] = [];
      this.suggested.forEach(element => {
        parti.push(element.anagrafica);
      });
      this.entities.forEach(entity => {
        const parteExtracted = extractParteEntityFromSearch(this.tipoPersonaOptions, entity, parti);
        if (parteExtracted) {
          if (entity) {
            if(entity.valore.includes('categoria: ') && entity.valore.includes('tipoSoggetto: ')) {
              categoria = entity.valore.substring(entity.valore.indexOf('categoria: ') + 'categoria: '.length, (entity.valore.indexOf(' tipoSoggetto: ')));
              tipoSoggetto = entity.valore.substring(entity.valore.indexOf('tipoSoggetto: ') + 'tipoSoggetto: '.length);
            } else {
              categoria = null;
              tipoSoggetto = null;
            }
          }
            let isAssociable = isParteAssociable(parteExtracted);
          this.suggested.push({ isAssociable: isAssociable, isControparte: false, hasDetailsAnagrafica: false, anagrafica: parteExtracted, categoria: categoria !== '-' ? categoria : null, tipoSoggetto: tipoSoggetto != '-' ? tipoSoggetto : null });
        }
      });
    }
    this.checkParteisControparte();
  }


  readSezione(docAdded = false) {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO);
    let { tipoPratica, tipoFascicolo, idSezione } = this.getProps();
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/controparti`;
    if(!idSezione) return;
    this.operations.readSezione(url, idSezione).subscribe(response => {
      this.sezione = response.sezione;
      this.fascicolo = this.accordions[index].properties.fascicolo;
      this.controparti = response.sezione.controparti
      this.accordions[index].properties.sezione = response.sezione;
      this.accordions[index].properties.sezione["esn"] = NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO;
      // if(docAdded === true) {
        this.creazionePraticaStoreService.onSectionLoaded(response.sezione);
      // }
      this.creazionePraticaStoreService.setControparti(this.controparti);
      this.creazionePraticaStoreService.save();
      this.accordions[index].complete = true;
    });
  }

  onDeleteControparte(option?: { hasDetailsAnagrafica: boolean, controparte: Controparte }) {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO);
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneControparti;
    this.delete(index, idSezione, option)
  }

  onDropDownEvent(event: {
    controparte: Controparte,
    eventType: 'primaria' | 'allegato' | 'disattiva' | 'elimina'
  }) {
    switch (event.eventType) {
      case "elimina":
        let option = {hasDetailsAnagrafica: true, controparte: event.controparte}
        this.onDeleteControparte(option);
        break;
      case "allegato":
        this.attachDocument(event);
        break;
      case "disattiva":
        this.disattivaControparte(event);
        break;
      case "primaria":
        this.setAsPrimary(event);
        break;
      default:
        break;
    }
  }

  onDocumentEvent(event: {
    documento: DocumentoAllegato,
    controparte?: Controparte,
    entityId?: string,
    sezioneId?: string,
    eventType: 'nuova-versione' | 'storico' | 'modifica' | 'elimina' | 'metadati'
  }) {
    switch (event.eventType) {
      case "elimina":
        this.removeDoc(event.documento, event.entityId);
        break;
      case "metadati":
        this.displayDocUpdateMetadatiModal(event.documento);
        break;
      case "nuova-versione":
        this.showUploadNewVersionModal(event.documento);
        break;
      case "storico":
        this.showHistoryModal(event.documento);
        break;
      default:
        break;
    }
  }

  private removeDoc(documento: DocumentoAllegato, entityId: string) {
    this.operations.removeDocumentoToEntity(documento, this.getUrlRemoveDocFromControparte(), entityId)
      .subscribe(() =>{ 
        this.readSezione(true);
      });
  }

  private showHistoryModal(documento: DocumentoAllegato) {
    this.docVersionHistoryParti.initContentCreazioneRapida(documento, this.fascicolo, 'docVersionHistoryParti');
  }

  private displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    const ref = this.dialog.open(UpdateMetadatiComponent, {
      data: {
        style: { width: "70%"},
        title: 'Modifica metadati',
        documento: documento,
        fascicolo: this.fascicolo,
        tipoPratica: this.fascicolo?.praticaBase.tipoPratica.id
      }
    });
     ref.afterClosed.subscribe(event => {
      if(!event || event.closeEvent) {
        // documento.primary = false;
        return
      };
      if(!!event.response) {
        this.closeModalDocumentAndReadSezione();
      }
    });
  }

  private showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.docVersionUpdateModalParti.initFormCreazioneRapida(documento, 'docVersionUpdateModalParti');
  }

  private attachDocument(event: { controparte: Controparte; eventType: 'primaria' | 'allegato' | 'disattiva' | 'elimina'; }) {
    this.docAddModalParti.initFormAlternative(
      this.getUrlAddDocToControparte(), 
      this.sezione, 
      this.fascicolo.id, 
      false, 
      this.sezione.esn, 
      'Aggiungi documento - Controparte', 
      true, 
      event.controparte
    );
  }

  private getUrlAddDocToControparte() {
    return ServicePathsSettings.URL_ADD_DOCUMENTO_TO_CONTROPARTE;
  }

  private getUrlRemoveDocFromControparte() {
    return ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_CONTROPARTE;
  }

  private setAsPrimary(event: { controparte: Controparte; eventType: 'primaria' | 'allegato' | 'disattiva' | 'elimina'; }) {
    let { tipoPratica, tipoFascicolo, idSezione } = this.getProps();
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/controparti/${idSezione}/controparte/${event.controparte.id}/primaria`;
    this.operations.setControparteAsPrimaria(event.controparte.id, url, this.sezione.id).subscribe(
      () => this.readSezione()
    );
  }

  private disattivaControparte(event: { controparte: Controparte; eventType: 'primaria' | 'allegato' | 'disattiva' | 'elimina'; }) {
    let { tipoPratica, tipoFascicolo, idSezione } = this.getProps();
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/controparti/${idSezione}/controparte/${event.controparte.id}/ritirato`;
    this.operations.disattivaControparte(event.controparte.id, url, this.sezione.id).subscribe(
      () => this.readSezione()
    );
  }

  private getProps() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneControparti || null;
    return { tipoPratica, tipoFascicolo, idSezione };
  }
  closeModalDocumentAndReadSezione() {
    closeModal('docVersionUpdateModalParti')
    closeModal('docAddModalParti');
    this.readSezione(true);
  }

  reloadSearch() {
    this.searchElement.fromResult = this.options.length;
    this.isConcatSearch = true;
    this.waitResponseSearch = true;
    this.searchElement.manageValue(true);
  }
}
